import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";

const DEFAULTS = {
  logo_url: "",
  brand_name: "Phone Experts",
  brand_tagline: "Display parts hub",
  business_phone: "073968 71520",
  whatsapp_number: "917396871520",
  business_address: "Malkajgiri Rd, near bustop, Vishnupuri Colony, Anandbagh, Hyderabad, Secunderabad, Telangana 500047",
  business_hours: "Open · Closes 10:00 pm",
  promo_banner_text: "Android displays starting from ₹1499/- Only",
  hero_title_prefix: "Original-grade",
  hero_title_highlight: "mobile displays",
  hero_title_suffix: ", shipped anywhere in India.",
  hero_subtitle: "From iPhone OLEDs to Samsung AMOLEDs — compatible screens tested by real technicians, priced for real workshops. Free shipping on all orders. All-India delivery.",
  hero_stat_1_value: "50+", hero_stat_1_label: "Models covered",
  hero_stat_2_value: "48h", hero_stat_2_label: "Dispatch",
  hero_stat_3_value: "7d",  hero_stat_3_label: "Warranty",
  trust_badge: "Trusted by 500+ technicians",
  footer_tagline: "Genuine compatible mobile displays for every model. Trusted by 500+ repair technicians across India.",
  about_intro: "We've been repairing mobiles at our Hyderabad store for years. This shop is our way of getting the same tested-in-store compatible displays into the hands of technicians and DIY-ers across India.",
};

const Ctx = createContext({ settings: DEFAULTS, refresh: () => {} });
export const useSiteSettings = () => useContext(Ctx);

export function SiteSettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);

  const refresh = () => {
    api.get("/site-settings").then((r) => {
      setSettings({ ...DEFAULTS, ...(r.data || {}) });
    }).catch(() => {});
  };

  useEffect(() => { refresh(); }, []);

  const value = useMemo(() => ({ settings, refresh }), [settings]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}
